module.exports = __webpack_public_path__ + "static/media/sensa.dfe9d06f.svg";